export enum RelativeDate {
  TODAY = 'Today',
  TOMORROW = 'Tomorrow',
  YESTERDAY = 'Yesterday',
  ONE_WEEK_AGO = 'One Week Ago',
  ONE_WEEK_FROM_NOW = 'One Week From Now',
  THIRTY_DAYS_AGO = '30 Days Ago',
  SIXTY_DAYS_AGO = '60 Days Ago',
  NINETY_DAYS_AGO = '90 Days Ago',
  CUSTOM = 'Custom Date',
}
